import React, { useState } from 'react';
import { Layout, Tabs, Button, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import LeaveTable from '../components/LeaveTable';
import ActionPendingTab from '../components/ActionPendingTab';
import LeaveForm from '../components/LeaveForm';
import { useSelector } from 'react-redux';
import { canApproveLeaves } from '../utils/permissions';

function Leave() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const items = [
    {
      key: '1',
      label: 'My Leaves',
      children: (
        <div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setIsModalOpen(true)}
            style={{ marginBottom: '20px' }}
          >
            Apply for Leave
          </Button>
          <LeaveTable showApprovalActions={false} showMyLeavesOnly={true} />
        </div>
      )
    },
    ...(canApproveLeaves(user) ? [{
      key: '2',
      label: 'Action Pending',
      children: <ActionPendingTab />
    }] : []),
    ...(canApproveLeaves(user) ? [{
      key: '3',
      label: 'All Leaves',
      children: <LeaveTable showApprovalActions={true} showMyLeavesOnly={false} />
    }] : [])
  ];

  return (
    <Layout style={{ padding: '20px' }}>
      <h1>Leave Management</h1>
      <Tabs items={items} />
      <Modal
        title="Apply for Leave"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={600}
      >
        <LeaveForm onSuccess={() => setIsModalOpen(false)} />
      </Modal>
    </Layout>
  );
}

export default Leave;
